// extracted by mini-css-extract-plugin
export default {"box":"SingleLayout_box__KeXQO","content":"SingleLayout_content__+qutU","gap":"SingleLayout_gap__4LWNR","back":"SingleLayout_back__dvW1g","backTxt":"SingleLayout_backTxt__OuuSU"};